import { render, staticRenderFns } from "./gallery-slider.vue?vue&type=template&id=748db9b9"
import script from "./gallery-slider.vue?vue&type=script&lang=js"
export * from "./gallery-slider.vue?vue&type=script&lang=js"
import style0 from "./gallery-slider.vue?vue&type=style&index=0&id=748db9b9&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/e/www/php7/idealesresort.gr/public/site/idealesresort/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748db9b9')) {
      api.createRecord('748db9b9', component.options)
    } else {
      api.reload('748db9b9', component.options)
    }
    module.hot.accept("./gallery-slider.vue?vue&type=template&id=748db9b9", function () {
      api.rerender('748db9b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/gallery-slider.vue"
export default component.exports